import {Pipe, PipeTransform} from '@angular/core';
import {RotationOrder} from "../model/rotationOrder";
import {Product} from "../model/product";

@Pipe({
    name: 'uniqueRotationOrders'
})
export class UniqueRotationOrdersPipe implements PipeTransform {

    /**
     * Filter all duplicate entries from an array of rotationOrders based on if the rotation orders cover the same
     * products and the day and month they should be ordered
     *
     * @param rotationOrders RotationOrders that should be filtered
     */
    transform(rotationOrders: RotationOrder[]) {
        return rotationOrders.reduce((uniqueRotationOrders: RotationOrder[], rotationOrder) => {
            if (this.isUniqueOrder(uniqueRotationOrders, rotationOrder)) {
                uniqueRotationOrders.push(rotationOrder);
            }
            return uniqueRotationOrders;
        }, []);
    }

    /**
     * Checks if a specific rotation order contains a product with a matching short name
     *
     * @param rotationOrder Rotation order which contains an array of products which should be checked for a specific product
     * @param product Specific product for which should be looked in the products of the rotation order
     * @return true if the rotation order contains the specific product else false
     */
    private hasMatchingProduct(rotationOrder: RotationOrder, product: Product): boolean{
        return rotationOrder.products.some(p => p.nameShort === product.nameShort)
    }

    /**
     * Checks if a specific rotation order is unique amongst an array of rotation orders.
     * A rotation order is unique if no other order has the same day, month and  a product with the same nameShort
     *
     * @param uniqueOrders An array of rotation orders that are unique
     * @param rotationOrder Rotation that should be checked if its unique
     * @return true if the rotation order is a unique order else false
     */
    private isUniqueOrder(uniqueOrders: RotationOrder[], rotationOrder: RotationOrder): boolean{
        return !uniqueOrders.some(uniqueOrder =>
            uniqueOrder.products.some(product => this.hasMatchingProduct(rotationOrder, product)) &&
            uniqueOrder.day === rotationOrder.day &&
            uniqueOrder.month === rotationOrder.month
        );
    }
}
